/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ガス契約情報
 */
export interface Szoa308aResponseGasAceptSearchResultDtoGasConInfo {
    /**
     * 導管事業者コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C300080」のユーザコードを設定
     */
    cndtBusCode?: string;
    /**
     * 導管事業者名称：全半角混在
     */
    cndtBusAname?: string;
    /**
     * ガス供給地点特定番号：数字
     */
    gasSuppntSpno?: string;
    /**
     * 指定日検針日区分コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C300090」のユーザコードを設定
     */
    siteiKensinDiv?: string;
    /**
     * 指定日検針日区分コード名称：全半角混在
     */
    siteiKensinDivAname?: string;
    /**
     * 検針日程：数字
     */
    kensinSchdl?: string;
    /**
     * 受入地点コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C300950」のユーザコードを設定
     */
    acsptPointCode?: string;
    /**
     * 受入地点コード名称：全半角混在
     */
    acsptPointCodeAname?: string;
    /**
     * 払出エリアコード：英数字<br>　コード変換マスターテーブル.画面項目ID「C410010」のユーザコードを設定
     */
    payoutAreaCode?: string;
    /**
     * 払出エリア名称：全半角混在
     */
    payoutAreaAname?: string;
    /**
     * 託送契約番号：英数字
     */
    cnsgmtCtrNo?: string;
    /**
     * 託送供給契約約款区分コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C300960」のユーザコードを設定
     */
    chargeCategCode?: string;
    /**
     * 託送供給契約約款区分名称：全半角混在
     */
    chargeCategCodeAname?: string;
    /**
     * 転売有無フラグ：英数字<br>　コード変換マスターテーブル.画面項目ID「C410020」のユーザコードを設定
     */
    resaleFlg?: string;
    /**
     * 転売有無名称：全半角混在
     */
    resaleFlgAname?: string;
    /**
     * 転売先事業者コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C410220」のユーザコードを設定
     */
    resaleBusCode?: string;
    /**
     * 転売先事業者名称：全半角混在
     */
    resaleBusAname?: string;
    /**
     * 最終供給事業者コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C410230」のユーザコードを設定
     */
    finalSupplierCode?: string;
    /**
     * 最終供給事業者名称：全半角混在
     */
    finalSupplierAname?: string;
    /**
     * 最終供給事業者連絡先：半角
     */
    finalSupplierTel?: string;
    /**
     * 負荷計測器工事有無フラグ：英数字<br>　コード変換マスターテーブル.画面項目ID「C410050」のユーザコードを設定
     */
    hukakeConstFlg?: string;
    /**
     * 負荷計測器工事有無名称：全半角混在
     */
    hukakeConstFlgAname?: string;
    /**
     * ガスメーター能力
     */
    gasMeterAbility?: number;
    /**
     * 供給管圧力区分コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C000490」のユーザコードを設定
     */
    supplyPipeAtrkDiv?: string;
    /**
     * 供給管圧力：全半角混在
     */
    supplyPipeAtrkAname?: string;
    /**
     * 契約開始日区分指定理由：全角
     */
    ctrstrDateDivSpecifyReason?: string;
    /**
     * 廃止取次有無フラグ：英数字<br>　コード変換マスターテーブル.画面項目ID「C410070」のユーザコードを設定
     */
    ablcomFlg?: string;
    /**
     * 廃止取次有無名称：全半角混在
     */
    ablcomFlgAname?: string;
    /**
     * 現小売事業者お客さま番号：英数字
     */
    oldretCustomerNo?: string;
    /**
     * 契約終了日区分指定理由：全角
     */
    ctrendDateDivSpecifyReason?: string;
    /**
     * 閉栓理由区分コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C410100」のユーザコードを設定
     */
    closingRsncod?: string;
    /**
     * 閉栓理由区分名称：全半角混在
     */
    closingRsnAname?: string;
    /**
     * その他特記事項：全角
     */
    othersMemo?: string;
}

